import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import fetch from 'features/common/fetch';
import user from 'features/views/user';
import { getParameterByName } from 'utils';

import Skeleton from './Skeleton';

// Provides application with user info and sets role depending on query parameters
const UserRole = ({ children }) => {
	const dispatch = useDispatch();
	const { search } = useLocation();

	const userFetched = useSelector(user.selectors.getUserFetched);
	const isUserFetching = useSelector(fetch.selectors.getIsFetching(`${fetch.constants.urls.user}.placeholder`));

	useEffect(() => {
		dispatch(user.actions.fetchAdditionalUserInfoWithPlaceholder());
		const role = getParameterByName('role', search);

		if (role) {
			dispatch(user.actions.setRole(role));
		}
		// eslint-disable-next-line
	}, []);

	if (!userFetched || isUserFetching) {
		return <Skeleton />;
	}

	return children;
};

UserRole.propTypes = {
	children: PropTypes.any,
};

export default UserRole;
